import React from 'react';
import { Sparkles } from 'lucide-react';
export function Proof() {
  return <section className="py-16 md:py-24" data-id="element-158">
      <div className="container mx-auto px-4" data-id="element-159">
        <div className="max-w-3xl mx-auto text-center" data-id="element-160">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-amber-500/10 text-amber-400 text-sm font-medium mb-8 border border-amber-500/20" data-id="element-161">
            <Sparkles size={16} data-id="element-162" />
            Lo que cambia en 7 días
          </div>

          <h2 className="text-3xl md:text-4xl mb-8 leading-tight" data-id="element-163">
            Recupera la confianza de que tu mente sigue siendo tu herramienta
            más poderosa.
          </h2>

          <p className="text-xl text-steel-300 leading-relaxed" data-id="element-164">
            Notarás que las palabras fluyen más rápido en las conversaciones y
            el "pánico de los olvidos" desaparece al despertar.
          </p>
        </div>
      </div>
    </section>;
}